(function () {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    window.addEventListener('load', function () {
        var preloader = document.getElementById('preloader');
        var delay = preloader ? 2.2 : 0;

        gsap.delayedCall(delay, function () {
            heroAnimation();
            scrollAnimations();
            valuesTimeline();
            parallaxEffects();
            counterAnimation();
        });
    });

    // Hero Animation
    function heroAnimation() {
        if (!document.querySelector('.hero__label')) return;

        var tl = gsap.timeline();

        tl.fromTo('.hero__label',
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' }
        )
        .fromTo('.hero__title-word',
            { y: 80, opacity: 0 },
            { y: 0, opacity: 1, duration: 1, stagger: 0.12, ease: 'power3.out' },
            '-=0.4'
        )
        .fromTo('.hero__subtitle',
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' },
            '-=0.5'
        )
        .fromTo('.hero__actions .btn',
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.1, duration: 0.6, ease: 'power3.out' },
            '-=0.4'
        )
        .fromTo('.hero__stat',
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.1, duration: 0.6, ease: 'power3.out' },
            '-=0.3'
        )
        .fromTo('.hero__scroll',
            { opacity: 0 },
            { opacity: 1, duration: 0.6 },
            '-=0.3'
        );
    }

    // Scroll-Triggered Animations
    function scrollAnimations() {
        // Section titles
        gsap.utils.toArray('.split-text').forEach(function (el) {
            gsap.fromTo(el,
                { y: 50, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 1,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 85%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });

        // Section labels
        gsap.utils.toArray('.section-label').forEach(function (el) {
            gsap.fromTo(el,
                { x: -30, opacity: 0 },
                {
                    x: 0, opacity: 1,
                    duration: 0.8,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 90%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });

        // Reveal text paragraphs
        gsap.utils.toArray('.reveal-text').forEach(function (el) {
            gsap.fromTo(el,
                { y: 30, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 0.8,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 88%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });

        // About signature
        var sig = document.querySelector('.about__signature');
        if (sig) {
            gsap.fromTo(sig,
                { y: 20, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 0.8,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: sig,
                        start: 'top 90%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        }

        // Reveal images
        gsap.utils.toArray('.reveal-image').forEach(function (el) {
            var img = el.querySelector('img');
            if (!img) return;

            gsap.fromTo(img,
                { scale: 1.2, opacity: 0 },
                {
                    scale: 1, opacity: 1,
                    duration: 1.4,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: el,
                        start: 'top 80%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });

        // Service cards
        gsap.utils.toArray('.service-card').forEach(function (card, i) {
            gsap.fromTo(card,
                { y: 50, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 0.8,
                    delay: i * 0.15,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: card,
                        start: 'top 85%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });

        // Project items
        gsap.utils.toArray('.project-item').forEach(function (item) {
            var content = item.querySelector('.project-item__content');
            if (!content) return;

            gsap.fromTo(content.children,
                { y: 40, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    stagger: 0.1,
                    duration: 0.8,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 75%',
                        toggleActions: 'play none none none'
                    }
                }
            );

            var image = item.querySelector('.project-item__image img');
            if (image) {
                gsap.fromTo(image,
                    { scale: 1.1 },
                    {
                        scale: 1,
                        duration: 1.4,
                        ease: 'power3.out',
                        scrollTrigger: {
                            trigger: item,
                            start: 'top 85%',
                            toggleActions: 'play none none none'
                        }
                    }
                );
            }
        });

        // Team members
        gsap.utils.toArray('.team__member').forEach(function (card, i) {
            gsap.fromTo(card,
                { y: 50, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 0.8,
                    delay: i * 0.12,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: card,
                        start: 'top 85%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });

        // Consulting items
        gsap.utils.toArray('.consulting__item').forEach(function (item, i) {
            gsap.fromTo(item,
                { y: 40, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 0.8,
                    delay: i * 0.15,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 85%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });

        // CTA section
        var ctaInner = document.querySelector('.cta__inner');
        if (ctaInner) {
            gsap.fromTo(ctaInner,
                { y: 50, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 1,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: ctaInner,
                        start: 'top 80%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        }

        // Footer
        var footerTitle = document.querySelector('.footer__title');
        if (footerTitle) {
            gsap.fromTo(footerTitle,
                { y: 40, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 0.8,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: footerTitle,
                        start: 'top 85%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        }

        gsap.utils.toArray('.footer__info-block').forEach(function (block, i) {
            gsap.fromTo(block,
                { y: 30, opacity: 0 },
                {
                    y: 0, opacity: 1,
                    duration: 0.7,
                    delay: i * 0.12,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: block,
                        start: 'top 90%',
                        toggleActions: 'play none none none'
                    }
                }
            );
        });
    }

    // Values Grid Reveal
    function valuesTimeline() {
        var cards = gsap.utils.toArray('.value-card');
        if (!cards.length) return;

        cards.forEach(function (card) {
            gsap.fromTo(card,
                { opacity: 0, y: 40 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.7,
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: card,
                        start: 'top 85%',
                        toggleActions: 'play none none none',
                    }
                }
            );
        });
    }

    // Parallax Effects
    function parallaxEffects() {
        // Hero shrink on scroll
        if (document.querySelector('.hero')) {
            var heroShrinkTl = gsap.timeline({
                scrollTrigger: {
                    trigger: '.hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                    pin: true,
                    pinSpacing: false
                }
            });

            heroShrinkTl
                .to('.hero', {
                    scale: 0.92,
                    borderRadius: '24px',
                    ease: 'none',
                }, 0)
                .to('.hero__bg-video, .hero__bg-img', {
                    yPercent: 10,
                    ease: 'none',
                }, 0)
                .to('.hero__content, .hero__stats, .hero__scroll', {
                    opacity: 0,
                    y: -40,
                    ease: 'none',
                }, 0);
        }

        // About images
        gsap.utils.toArray('.about__image img').forEach(function (img) {
            gsap.to(img, {
                yPercent: -10,
                ease: 'none',
                scrollTrigger: {
                    trigger: img.closest('.about__image'),
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });

        // Parallax break
        gsap.utils.toArray('.parallax-break__image img').forEach(function (img) {
            gsap.to(img, {
                yPercent: 20,
                ease: 'none',
                scrollTrigger: {
                    trigger: img.closest('.parallax-break'),
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        });

        // Consulting background
        var consultBg = document.querySelector('.consulting__bg img');
        if (consultBg) {
            gsap.to(consultBg, {
                yPercent: 15,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.consulting',
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        }

        // CTA background
        var ctaBg = document.querySelector('.cta__bg img');
        if (ctaBg) {
            gsap.to(ctaBg, {
                yPercent: 10,
                ease: 'none',
                scrollTrigger: {
                    trigger: '.cta',
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                }
            });
        }
    }

    // Counter Animation
    function counterAnimation() {
        document.querySelectorAll('.hero__stat-num').forEach(function (el) {
            var target = parseInt(el.getAttribute('data-count'), 10);
            var obj = { val: 0 };

            gsap.to(obj, {
                val: target,
                duration: 2,
                delay: 0.3,
                ease: 'power2.out',
                onUpdate: function () {
                    el.textContent = Math.round(obj.val);
                }
            });
        });
    }
})();
